import { Component, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { DocumentService } from 'app/modules/borrower/models/document/document.service';
import { fade } from 'app/util/animations/fade';
import { notNull } from 'app/modules/shared/functions/filters';
import { StatementMonthRequirement } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { messageFromError } from 'app/util/http';

@Component({
    selector: 'bank-requirements',
    templateUrl: 'bank-requirements.component.html',
    animations: [fade],
    standalone: false
})
export class BankRequirementsComponent implements OnChanges {

    @Input() bankRequirements: StatementMonthRequirement[];
    @Input() borrowerId: number;

    @Output() met = new EventEmitter<void>();

    errorMessage: string | null = null;
    processBtnVisible = false;
    processBtnDisabled = false;

    constructor(private documentService: DocumentService) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('bankRequirements')) {
            this.calculateProcessBtnVisibility();
        }
    }

    process() {
        this.errorMessage = null;
        this.processBtnDisabled = true;
        this.documentService.sendToOcrolus(this.borrowerId, this.docIdsToProcess(), true).subscribe({
            next: (documents) => {

                // Optimistically update document status
                documents.forEach((document) => {
                    const req = this.bankRequirements.find((bankReq) => bankReq.documentId === document.id);
                    if (req) {
                        req.status = 'processing';
                    }
                });
                this.processBtnDisabled = false;
                this.calculateProcessBtnVisibility();

                if (this.allRequirementsMet()) {
                    this.met.emit();
                }
            },
            error: (error) => {

                // Log error
                const message = messageFromError(error);
                console.error(message, error);

                // Notify user
                this.errorMessage = 'Error processing documents';
                this.processBtnDisabled = false;
            }
          });
    }

    private allRequirementsMet() {
        return this.bankRequirements.every((req) => !['needed', 'unprocessed', 'failed'].includes(req.status));
    }

    private calculateProcessBtnVisibility() {
        this.processBtnVisible = this.bankRequirements?.some((monthReq) => monthReq.status === 'unprocessed');

        // Ensure the process button is enabled it is visible and the requirements have changed
        if (this.processBtnVisible && this.processBtnDisabled) {
            this.processBtnDisabled = false;
        }
    }

    private docIdsToProcess(): number[] {
        return this.bankRequirements.filter((r) => r.status === 'unprocessed')
            .map((r) => r.documentId)
            .filter(notNull) as number[];
    }
}
